// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--eMWRA";
export var footerInner = "footer-module--footer-inner--3zBR_";
export var fb = "footer-module--fb--2obUN";
export var legal = "footer-module--legal--3YH_k";